export const EthocaLogo = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    height="60.392"
    viewBox="0 0 86.09 52.52"
    xmlSpace="preserve"
  >
    <g>
      <g>
        <rect x="64.1" y="32.5" fill="#FF5F00" width="6.37" height="11.45" />
        <g>
          <g>
            <path
              fill="#EB001B"
              d="M64.51,38.22c0-2.32,1.09-4.39,2.78-5.72c-1.24-0.98-2.8-1.56-4.5-1.56c-4.02,0-7.28,3.26-7.28,7.28
					s3.26,7.28,7.28,7.28c1.7,0,3.26-0.58,4.5-1.56C65.6,42.61,64.51,40.54,64.51,38.22"
            />
            <path
              fill="#F79E1B"
              d="M79.07,38.22c0,4.02-3.26,7.28-7.28,7.28c-1.7,0-3.26-0.58-4.5-1.56c1.69-1.33,2.78-3.4,2.78-5.72
					c0-2.32-1.09-4.39-2.78-5.72c1.24-0.98,2.8-1.56,4.5-1.56C75.81,30.94,79.07,34.2,79.07,38.22"
            />
            <path
              fill="#F79E1B"
              d="M78.37,42.73V42.5h0.09v-0.05h-0.24v0.05h0.09v0.23H78.37z M78.84,42.73v-0.28h-0.07l-0.08,0.19l-0.09-0.19
					h-0.07v0.28h0.05v-0.21l0.08,0.18h0.05l0.08-0.18v0.21H78.84z"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          fill="#FFFFFF"
          d="M44.72,36.18c0.29,0,0.57,0.06,0.82,0.17c0.26,0.11,0.48,0.26,0.67,0.46c0.19,0.2,0.34,0.43,0.45,0.7
			c0.11,0.27,0.16,0.57,0.16,0.89c0,0.32-0.05,0.62-0.16,0.89c-0.11,0.27-0.26,0.5-0.45,0.7c-0.19,0.2-0.41,0.35-0.67,0.46
			c-0.26,0.11-0.53,0.16-0.82,0.16c-0.3,0-0.56-0.06-0.78-0.17c-0.21-0.11-0.4-0.26-0.54-0.44v0.5h-0.92v-6.33h0.92v2.62
			c0.15-0.18,0.33-0.33,0.54-0.44C44.16,36.24,44.42,36.18,44.72,36.18z M44.61,37.05c-0.19,0-0.36,0.03-0.52,0.1
			c-0.16,0.07-0.29,0.16-0.4,0.28s-0.2,0.26-0.26,0.43s-0.09,0.34-0.09,0.54c0,0.19,0.03,0.37,0.09,0.54s0.15,0.31,0.26,0.43
			s0.24,0.21,0.4,0.28c0.16,0.07,0.33,0.1,0.52,0.1c0.2,0,0.37-0.04,0.53-0.11c0.16-0.07,0.29-0.17,0.4-0.29
			c0.11-0.12,0.19-0.26,0.25-0.43s0.09-0.34,0.09-0.52c0-0.18-0.03-0.36-0.09-0.52s-0.14-0.31-0.25-0.43
			c-0.11-0.12-0.24-0.22-0.4-0.29C44.98,37.08,44.81,37.05,44.61,37.05z"
        />
        <path fill="#FFFFFF" d="M48.5,42.28h-1.02l1.51-2.65l-1.87-3.34h1.03l1.35,2.42l1.3-2.42h1.01L48.5,42.28z" />
      </g>
      <g>
        <path
          fill="#FFFFFF"
          d="M12.38,12.59c0.72,0,1.39,0.14,2.01,0.41c0.62,0.27,1.15,0.65,1.6,1.14c0.45,0.49,0.8,1.07,1.06,1.75
			s0.4,1.42,0.4,2.23c0,0.1,0,0.19-0.01,0.28c0,0.09-0.01,0.17-0.02,0.26H8.36c0.05,0.63,0.19,1.19,0.42,1.68
			c0.23,0.49,0.54,0.91,0.91,1.25c0.38,0.34,0.81,0.6,1.29,0.78c0.49,0.18,1.01,0.26,1.56,0.26c0.76,0,1.44-0.14,2.04-0.41
			c0.6-0.28,1.14-0.65,1.62-1.13l0.7,0.9c-0.34,0.34-0.7,0.63-1.05,0.86c-0.36,0.23-0.72,0.41-1.09,0.55
			c-0.37,0.14-0.75,0.23-1.13,0.29s-0.77,0.08-1.16,0.08c-0.79,0-1.52-0.14-2.19-0.41c-0.67-0.27-1.24-0.65-1.73-1.14
			c-0.48-0.49-0.86-1.08-1.13-1.76c-0.27-0.68-0.4-1.44-0.4-2.26c0-0.81,0.14-1.56,0.41-2.25c0.27-0.69,0.65-1.28,1.13-1.77
			c0.48-0.5,1.05-0.88,1.7-1.16C10.91,12.73,11.62,12.59,12.38,12.59z M12.36,13.75c-0.55,0-1.06,0.09-1.51,0.28
			c-0.46,0.19-0.86,0.45-1.2,0.78C9.3,15.15,9.02,15.54,8.8,16c-0.22,0.46-0.36,0.97-0.42,1.52h7.74c-0.05-0.56-0.17-1.07-0.38-1.54
			c-0.21-0.46-0.48-0.86-0.81-1.19c-0.33-0.33-0.72-0.59-1.16-0.77C13.34,13.84,12.86,13.75,12.36,13.75z"
        />
        <path
          fill="#FFFFFF"
          d="M27.41,13.96h-4.99v5.9c0,0.46,0.06,0.86,0.17,1.19c0.11,0.33,0.28,0.61,0.49,0.83
			c0.21,0.22,0.46,0.38,0.76,0.49s0.62,0.16,0.98,0.16c0.47,0,0.91-0.08,1.32-0.22c0.41-0.15,0.78-0.35,1.1-0.6l0.62,0.98
			c-0.39,0.32-0.85,0.58-1.37,0.78c-0.53,0.2-1.11,0.3-1.77,0.3c-1.13,0-2.01-0.32-2.65-0.96c-0.64-0.64-0.96-1.61-0.96-2.92v-5.92
			h-2.48v-1.2h2.48V9.23h1.31v3.53h4.99V13.96z"
        />
        <path
          fill="#FFFFFF"
          d="M31.33,14.64c0.21-0.35,0.47-0.66,0.75-0.92c0.29-0.26,0.6-0.47,0.94-0.64c0.34-0.17,0.69-0.29,1.06-0.37
			c0.37-0.08,0.74-0.12,1.1-0.12c0.67,0,1.29,0.1,1.85,0.3c0.56,0.2,1.04,0.49,1.44,0.87c0.4,0.38,0.71,0.83,0.93,1.37
			c0.22,0.54,0.33,1.14,0.33,1.81v6.64h-1.31v-6.23c0-0.54-0.08-1.04-0.23-1.47c-0.15-0.44-0.38-0.81-0.68-1.11
			c-0.3-0.3-0.66-0.54-1.09-0.7c-0.43-0.16-0.92-0.24-1.47-0.24c-0.51,0-0.98,0.09-1.42,0.26c-0.44,0.17-0.82,0.42-1.15,0.74
			c-0.33,0.32-0.58,0.7-0.77,1.14c-0.19,0.44-0.28,0.93-0.28,1.45v6.16h-1.31V7.02h1.31V14.64z"
        />
        <path
          fill="#FFFFFF"
          d="M47.86,12.59c0.81,0,1.55,0.14,2.24,0.43c0.69,0.28,1.28,0.67,1.78,1.17c0.5,0.5,0.9,1.09,1.18,1.77
			s0.43,1.42,0.43,2.22c0,0.8-0.14,1.54-0.43,2.21c-0.29,0.68-0.68,1.27-1.18,1.77c-0.5,0.5-1.1,0.89-1.78,1.17
			c-0.69,0.28-1.43,0.43-2.24,0.43c-0.8,0-1.55-0.14-2.23-0.43c-0.68-0.28-1.27-0.67-1.78-1.17c-0.5-0.5-0.9-1.09-1.18-1.77
			c-0.28-0.68-0.43-1.42-0.43-2.21c0-0.8,0.14-1.54,0.43-2.22s0.68-1.27,1.18-1.77c0.5-0.5,1.09-0.89,1.78-1.17
			C46.31,12.73,47.05,12.59,47.86,12.59z M47.86,13.82c-0.61,0-1.17,0.11-1.69,0.33s-0.97,0.52-1.36,0.91
			c-0.38,0.39-0.68,0.85-0.9,1.38c-0.22,0.53-0.33,1.11-0.33,1.74c0,0.63,0.11,1.21,0.33,1.74c0.22,0.53,0.52,0.99,0.9,1.37
			c0.38,0.38,0.84,0.68,1.36,0.9s1.08,0.33,1.69,0.33c0.61,0,1.17-0.11,1.7-0.33c0.53-0.22,0.98-0.52,1.36-0.9
			c0.38-0.38,0.68-0.84,0.9-1.37c0.22-0.53,0.33-1.11,0.33-1.74c0-0.63-0.11-1.21-0.33-1.74c-0.22-0.53-0.52-0.99-0.9-1.38
			c-0.38-0.39-0.84-0.69-1.36-0.91C49.03,13.93,48.46,13.82,47.86,13.82z"
        />
        <path
          fill="#FFFFFF"
          d="M60.81,12.59c0.8,0,1.55,0.14,2.24,0.43c0.69,0.29,1.27,0.7,1.75,1.25l-0.85,0.88
			c-0.42-0.42-0.9-0.75-1.42-0.98c-0.53-0.23-1.11-0.35-1.75-0.35c-0.59,0-1.14,0.11-1.65,0.33c-0.51,0.22-0.95,0.52-1.33,0.91
			c-0.38,0.39-0.67,0.85-0.88,1.38c-0.21,0.53-0.32,1.11-0.32,1.74c0,0.63,0.11,1.21,0.32,1.74c0.21,0.53,0.5,0.99,0.88,1.37
			c0.38,0.38,0.82,0.68,1.33,0.9c0.51,0.22,1.06,0.33,1.65,0.33c0.64,0,1.24-0.12,1.78-0.37c0.54-0.25,1.02-0.57,1.43-0.98l0.82,0.9
			c-0.49,0.54-1.08,0.96-1.76,1.25c-0.68,0.29-1.43,0.43-2.23,0.43c-0.81,0-1.56-0.14-2.24-0.43c-0.68-0.28-1.26-0.67-1.75-1.17
			c-0.49-0.5-0.87-1.09-1.14-1.77c-0.27-0.68-0.41-1.42-0.41-2.21c0-0.8,0.14-1.54,0.41-2.22c0.27-0.68,0.65-1.27,1.14-1.77
			c0.49-0.5,1.08-0.89,1.75-1.17C59.25,12.73,59.99,12.59,60.81,12.59z"
        />
        <path
          fill="#FFFFFF"
          d="M77.39,23.58h-1.3V21.5c-0.44,0.68-1.01,1.23-1.73,1.64s-1.57,0.62-2.56,0.62c-0.76,0-1.47-0.14-2.13-0.42
			c-0.66-0.28-1.23-0.67-1.71-1.16c-0.48-0.5-0.86-1.08-1.14-1.77s-0.42-1.43-0.42-2.23c0-0.81,0.14-1.55,0.42-2.23
			s0.66-1.27,1.14-1.77c0.48-0.5,1.05-0.89,1.71-1.17c0.66-0.28,1.37-0.42,2.13-0.42c0.99,0,1.84,0.21,2.56,0.62
			s1.29,0.96,1.73,1.63v-2.08h1.3V23.58z M71.95,13.82c-0.62,0-1.19,0.11-1.71,0.34c-0.52,0.23-0.96,0.53-1.33,0.93
			c-0.37,0.39-0.66,0.85-0.87,1.38s-0.31,1.1-0.31,1.71s0.1,1.18,0.31,1.71s0.5,0.99,0.87,1.38c0.38,0.39,0.82,0.7,1.34,0.92
			c0.52,0.22,1.08,0.33,1.7,0.33s1.18-0.11,1.69-0.33s0.96-0.52,1.33-0.91s0.67-0.85,0.87-1.38s0.31-1.1,0.31-1.72
			c0-0.62-0.1-1.2-0.31-1.73c-0.21-0.53-0.5-0.99-0.87-1.38c-0.38-0.39-0.82-0.69-1.33-0.91S72.56,13.82,71.95,13.82z"
        />
      </g>
    </g>
  </svg>
);
